export function computeCaseVerdict(gates) {
    const byName = new Map(gates.map((g) => [g.gate, g.status]));
    if (byName.get("baseline") !== "pass")
        return "invalid";
    if (gates.some((g) => g.status === "fail"))
        return "regression";
    if (gates.some((g) => g.status === "inconclusive"))
        return "inconclusive";
    return "verified";
}
export function buildCaseOverview(input) {
    return {
        caseId: input.manifest.caseId,
        baselineCommit: input.manifest.repository.baselineCommit,
        patchedCommit: input.manifest.repository.patchedCommit,
        manifestHash: input.manifestHash,
        generatedAt: input.generatedAt,
        verdict: computeCaseVerdict(input.gates),
        gates: input.gates,
        scope: input.scope,
        variantDenominator: input.variantDenominator,
        expectedExploit: input.manifest.expectedExploit,
        invariant: input.manifest.invariant,
    };
}
function labelFor(node) {
    return node.functionName ?? node.selector ?? node.contractRole ?? node.address;
}
function toRailNode(node, relation, counterpartId) {
    return {
        id: node.id,
        parentId: node.parentId,
        depth: node.depth,
        label: labelFor(node),
        contractRole: node.contractRole,
        address: node.address,
        callType: node.callType,
        resultClass: node.result.class,
        semanticPath: node.semanticPath,
        msgValue: node.msgValue,
        storageWriteCount: node.storageWrites.length,
        eventCount: node.events.length,
        effectIds: node.effects.map((e) => e.id),
        children: node.children,
        relation,
        counterpartId,
    };
}
/** Builds one side's replay rail from its trace and the shared alignment. */
export function buildReplayRail(trace, alignment, side) {
    const records = side === "vulnerable"
        ? new Map(alignment.records
            .filter((r) => r.baselineNodeId !== undefined)
            .map((r) => [r.baselineNodeId, r]))
        : new Map(alignment.records
            .filter((r) => r.patchedNodeId !== undefined)
            .map((r) => [r.patchedNodeId, r]));
    return trace.nodes.map((node) => {
        const record = records.get(node.id);
        const counterpartId = record === undefined
            ? undefined
            : side === "vulnerable"
                ? record.patchedNodeId
                : record.baselineNodeId;
        return toRailNode(node, record?.relation, counterpartId);
    });
}
function resolveEffects(effects, ids) {
    const byId = new Map(effects.effects.map((e) => [e.id, e]));
    return ids.map((id) => byId.get(id)).filter((e) => e !== undefined);
}
export function buildCausalSeam(input) {
    const { divergence } = input;
    const record = divergence.divergence;
    const vulnerableById = new Map(input.vulnerableRail.map((n) => [n.id, n]));
    const patchedById = new Map(input.patchedRail.map((n) => [n.id, n]));
    return {
        status: record.status,
        baselineNode: record.baselineNodeId ? vulnerableById.get(record.baselineNodeId) : undefined,
        patchedNode: record.patchedNodeId ? patchedById.get(record.patchedNodeId) : undefined,
        relation: record.alignmentRelation,
        explainedEffects: resolveEffects(input.vulnerableEffects, record.explainedEffectIds),
        patchedEffects: resolveEffects(input.patchedEffects, record.patchedEffectIds),
        reasons: record.reasons,
    };
}
//# sourceMappingURL=views.js.map